<!-- AlertSection.vue -->
<script setup lang="ts">
import { computed } from 'vue';
import { MessageSectionType, DisplayStyle } from '../../Enums/UiEnums'
import { bootstrapAlertClass, bootstrapMarginBottomClass, bootstrapMarginTopClass, BootstrapPaddingValue, bootstrapTextClass, themeIconsClass } from '../../lib/StyleHelpers'

    const props = withDefaults(defineProps<{
            displayStyle?: DisplayStyle | string, 
            showIcon?: boolean,
            title?: string,
            dismissible?: boolean,
            marginTop?: BootstrapPaddingValue,
            marginBottom?: BootstrapPaddingValue
        }>(), {
            type: MessageSectionType.Row,
            displayStyle: DisplayStyle.Primary,
            showIcon: false,
            dismissible: false
        });

    const alertClass = computed<(string|undefined)[]>(() => {
        const dismissibleClass = props.dismissible ? " alert-dismissible" : "";
        return [bootstrapAlertClass(props.displayStyle, true), dismissibleClass, bootstrapMarginTopClass(props.marginTop), bootstrapMarginBottomClass(props.marginBottom)];
    });
</script>

<template>
    <div :class="alertClass" :title="props.title">
        <i v-if="showIcon" :class="themeIconsClass(props.displayStyle)" aria-hidden="true"></i>
        <slot></slot>
        <span v-if="props.dismissible">
            <button type="button" class="btn-close" data-bs-dismiss="alert" aria-label="Close"></button>
        </span>
    </div>
</template>